import { Link } from 'react-router-dom'
import { cn } from '@/lib/cn'
import { routes } from '@/routes'

interface LogoProps {
  className?: string
  /** Renderiza sem link — usado dentro do próprio cabeçalho do admin. */
  static?: boolean
  /**
   * Até `md`, mostra só o selo. É o que libera espaço para a busca ocupar a
   * linha inteira do cabeçalho no celular.
   */
  sealUntilMd?: boolean
}

/**
 * Marca do Mercado Prêmio.
 *
 * Reconstruída em SVG para não depender de arquivo de imagem. Para trocar pelo
 * asset oficial, substitua o conteúdo por <img src="/logo.svg" /> mantendo as
 * mesmas dimensões.
 */

/** Selo amarelo com o "p" — o "carimbo" da marca, e a versão reduzida dela. */
function SealShape() {
  return (
    <>
      <path
        d="M18 0.5 22.6 8.2 31.4 6.4 29.6 15.2 37.3 19.8 29.6 24.4 31.4 33.2 22.6 31.4 18 39.1 13.4 31.4 4.6 33.2 6.4 24.4 -1.3 19.8 6.4 15.2 4.6 6.4 13.4 8.2Z"
        fill="#ffc107"
      />
      <text
        x="18"
        y="27"
        textAnchor="middle"
        fill="#1a1a1a"
        fontFamily="Inter, Arial, sans-serif"
        fontSize="20"
        fontWeight="800"
      >
        p
      </text>
    </>
  )
}

function Mark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 148 44"
      className={cn('h-9 w-auto', className)}
      role="img"
      aria-label="Mercado Prêmio"
    >
      <text
        x="0"
        y="19"
        fill="#ffffff"
        fontFamily="Inter, Arial, sans-serif"
        fontSize="17"
        fontWeight="800"
        letterSpacing="-0.4"
      >
        mercado
      </text>
      <text
        x="0"
        y="38"
        fill="#ffffff"
        fontFamily="Inter, Arial, sans-serif"
        fontSize="17"
        fontWeight="800"
        letterSpacing="-0.4"
      >
        prêmio
      </text>
      <g transform="translate(104 6)">
        <SealShape />
      </g>
    </svg>
  )
}

/** Só o selo, sem o texto ao lado. */
function Seal({ className }: { className?: string }) {
  return (
    <svg
      viewBox="-2 -1 41 41"
      className={cn('h-9 w-auto', className)}
      role="img"
      aria-label="Mercado Prêmio"
    >
      <SealShape />
    </svg>
  )
}

export function Logo({ className, static: isStatic, sealUntilMd }: LogoProps) {
  // As duas versões convivem e o CSS decide qual aparece: assim a troca
  // acontece no resize sem depender de medir a tela no JavaScript.
  const mark = sealUntilMd ? (
    <>
      <Seal className={cn('md:hidden', className)} />
      <Mark className={cn('hidden md:block', className)} />
    </>
  ) : (
    <Mark className={className} />
  )

  if (isStatic) return mark

  return (
    <Link to={routes.home} className="shrink-0" aria-label="Mercado Prêmio — página inicial">
      {mark}
    </Link>
  )
}
